<template>
    <div>
        <div class="add-product-modal-overlay" @click="close()"></div>

        <div class="add-product-modal" v-if="loaded && !showIngredients && !showAdditionalSauces">
            <div v-if="!finished" class="add-product-modal__head">
                <img class="add-product-modal__head-img" :src="product.thumbnail" :alt="product.title">

                <div class="add-product-modal__head-info">
                    <div class="add-product-modal-close-section">
                        <div class="add-product-modal-title" style="padding-left: 0;" v-if="!finished">
                            {{ product.title }}
                            <span v-if="product.category_id == 1 && this.sizeName">({{ this.sizeName }})</span>
                            <span v-if="product.category_id != 1">({{ product.volume }} ml)</span>
                        </div>
                        <inline-svg src="/img/icons/close-box.svg" class="add-product-modal-close-icon" :fill="this.$store.state.nightMode ? 'white' : 'black'" @click="close()"></inline-svg>
                    </div>
                    <div class="add-product-modal-products" v-if="product.category_id == 1">
                        <span v-if="product.weight_30 > 0 || product.weight_50 > 0" class="product-box-description__weight">{{
                                sizeName == '30 см' ? product.weight_30 : product.weight_50
                        }} г – </span>
                        {{ product.description }}
                    </div>
                </div>
            </div>

            <div v-if="!finished" class="add-product-modal__quantity">
                <div class="add-product-modal-buttons-box">
                    <div class="add-product-modal__quantity-price">{{ getPrice() }} грн</div>
                </div>

                <div class="quantity-box">
                    <div class="quanity-button quanity-button--minus" @click="changeQuanity('minus')">
                        -
                    </div>
                    <input class="quanity-input" type="text" v-model="quanity">
                    <div class="quanity-button quanity-button--plus" @click="changeQuanity('plus')">
                        +
                    </div>
                </div>
            </div>

            <div v-if="!finished" class="add-product-modal__quantity">
                <div class="add-product-modal__total-price" style="margin: -6px 0 0 auto;">Сума: <span style="color: #AB2321;">{{ getPrice() * this.quanity }} грн</span></div>
            </div>

            <div v-if="!finished" class="add-product-modal-products-container">
                <div class="size-box" v-if="product.category_id == 1 && product.show_50 && product.show_30">
                    <div v-for="size in sizes" :key="size.name" :class="size.selected ? 'size-selected' : 'size'" @click="changeSize(size)">
                        {{ size.name }}
                    </div>
                </div>

                <ul class="ingredients__list" v-if="product.category_id == 1">
                    <li v-for="ingredient in ingredients"
                        v-if="ingredient.show_main && (sizeName == '30 см' || ingredient.available_50) && !(ingredient.is_black && product.is_black)"
                        :class="(checkSelectedIngredient(ingredient.id) ? 'ingredient-button-selected' : '') + ' ingredient-button ingredients__item'" @click="addIngredientManual(ingredient.id)">

                        <inline-svg class="checked-mark" src="/img/icons/check-mark.svg" width="20" height="20"></inline-svg>

                        <i class="unchecked-mark"></i>

                        {{ ingredient.title }}
                    </li>
                </ul>

                <div v-if="product.category_id == 1" class="ingredients">
                    <div class="add-product-modal-title">
                        Додаткові інгредієнти
                    </div>
                    <div class="ingredients-section">
                        <div v-for="ingredient in filteredIngredients" :key="ingredient.id"
                             :class="ingredient.selected ? 'ingredient-box ingredient-box-selected' : 'ingredient-box'"
                             @click="addIngredient(ingredient)">
                            <img :src="ingredient.thumbnail" class="ingredient-box__img">
                            <div class="ingredient-box__content">
                                <div v-html="ingredient.title" style="font-weight: bold"></div>
                                <div style="color: #AB2321; font-weight: 700">
                                    {{ sizeName == '30 см' ? ingredient.price : ingredient.price * 2 }} грн
                                </div>
                            </div>

                            <div style="position: absolute;top: 0;right: 0;padding-top: 2px;padding-right: 7px;"></div>
                        </div>
                    </div>
                    <div v-if="product.additionaIngredients.length" class="selected-ingredients">
                        <span class="selected-ingredients__title">Додатки: </span>
                        <span v-for="(ingredient, index) in product.additionaIngredients" :key="ingredient.index" v-if="isFirstIngredient(index, ingredient.id)"><span v-if="index != 0">, </span>{{ ingredient.title }}<span v-if="countSelectedIngredient(ingredient.id) > 1"> x{{ countSelectedIngredient(ingredient.id)}}</span>
                        </span>
                    </div>
                </div>

                <div v-if="product.category_id == 1" class="sauces">
                    <div class="add-product-modal-title">
                        Додатковий соус
                    </div>
                    <div class="ingredients-section">
                        <div v-for="sauce in sauces" :key="sauce.id" class="ingredient-box">
                            <div>
                                <img :src="sauce.thumbnail" class="ingredient-box__img" @click="addSauceManual(sauce.id)">
                                <div class="ingredient-box__content">
                                    <div v-html="sauce.title" style="font-weight: bold"></div>
                                    <div style="color: #AB2321;font-weight: 700">
                                        {{ sizeName == '30 см' ? sauce.price : sauce.price * 2 }} грн
                                    </div>
                                    <div class="quantity-box">
                                        <div class="quanity-button quanity-button--minus" @click="changeSauceQuanity('minus', sauce.id)">
                                            -
                                        </div>
                                        <div class="quanity-input">{{ getIngredientQuanity(sauce.id) }}</div>
                                        <div class="quanity-button quanity-button--plus" @click="changeSauceQuanity('plus', sauce.id)">
                                            +
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <button class="add-to-card-button" @click="addToCart()">В кошик</button>
            </div>

            <div v-if="finished" class="finished-section">
                <div>
                    Дякуємо!
                </div>
                <div style="margin-top: 14px">
                    <button type="button" class="btn btn-light" @click="routerToRoute('pizza')">Повернутись в меню</button>
                </div>
                <div style="margin-top: 14px">
                    <router-link :to="{name: 'cart', params: {locationCity: this.$route.params.locationCity}}" :params="{ locationCity: this.$route.params.locationCity }">
                        <button class="add-to-card-button make-order">Оформити замовлення
                        </button>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import InlineSvg from 'vue-inline-svg';

export default {
    components: {
        InlineSvg
    },
    data() {
        return {
            product: {},
            quanity: 1,
            sizes: [
                {
                    'name': '30 см', 'selected': true, 'selector': 'price_30', 'size': 30
                },
                {
                    'name': '50 см', 'selected': false, 'selector': 'price_50', 'size': 50
                }
            ],
            ingredients: [],
            filteredIngredients: [],
            sauces: [],
            sizeName: '30 см',
            sizeSelector: 'price_30',
            showIngredients: false,
            showAdditionalSauces: false,
            loaded: false,
            finished: false
        }
    },

    computed: {},

    methods: {
        close() {
            this.$emit('close');
        },

        getPrice() {
            let price = this.product.category_id == 1 ? this.product[this.sizeSelector] : this.product.price;
            this.product.additionaIngredients.forEach(ingredient => {
                price += parseInt(ingredient.price);
            });

            return price;
        },

        getPriceWithoutAdditionals() {
            return this.product.category_id == 1 ? this.product[this.sizeSelector] : this.product.price;
        },

        changeSize(size) {
            this.sizes.forEach(e => {
                e.selected = false;
            });

            this.product.additionaIngredients = [];
            this.sizeName = size.name;
            this.sizeSelector = size.selector;
            size.selected = true;
        },

        countSelectedIngredient(ingredientId) {
            let count = 0;
            this.product.additionaIngredients.forEach(e => {
                if(e.id == ingredientId) {
                    count++;
                }
            });

            return count;
        },

        isFirstIngredient(ingredientIndex, ingredientId) {
            let isFirstIngredient = null;
            this.product.additionaIngredients.forEach((item, index) => {
                console.log(ingredientIndex)
                if(item.id == ingredientId && isFirstIngredient == null) {
                    if(ingredientIndex == index) {
                        isFirstIngredient = true;
                    }
                    else {
                        isFirstIngredient = false;
                    }
                }
            });
            console.log(isFirstIngredient);

            return isFirstIngredient;
        },

        addIngredient(ingredient) {
            let index = this.ingredients.findIndex(e => e.id == ingredient.id);
            if (!this.ingredients[index].selected) {
                if (this.sizeName == '50 см') {
                    ingredient = JSON.parse(JSON.stringify(ingredient));
                    ingredient.title = ingredient.title + ' (велика піца)';
                    ingredient.price = ingredient.price * 2;
                }
                this.$set(this.ingredients[index], 'selected', true);
                this.product.additionaIngredients.push(ingredient);
                return;
            }

            if (this.ingredients[index].selected) {
                this.$set(this.ingredients[index], 'selected', false);
                let ingredientIndex = this.product.additionaIngredients.findIndex(e => e.id == ingredient.id);
                this.product.additionaIngredients.splice(ingredientIndex, 1);

            }
        },

        checkSelectedIngredient(id) {
            let ingredient = this.product.additionaIngredients.findIndex(e => e.id == id);
            return ingredient == -1 ? false : true;
        },

        addIngredientManual(id) {
            let index = this.ingredients.findIndex(e => e.id == id);
            let ingredient = this.ingredients[index];
            this.addIngredient(ingredient);
            this.$forceUpdate();
        },

        addSauceManual(id) {
            let index = this.ingredients.findIndex(e => e.id == id);
            let ingredient = this.ingredients[index];
            this.addIngredient(ingredient);
            this.$forceUpdate();
        },

        addSauce(ingredient) {
            let index = this.ingredients.findIndex(e => e.id == ingredient.id);
            this.$set(this.ingredients[index], 'selected', true);

            if (this.sizeName == '50 см') {
                ingredient = JSON.parse(JSON.stringify(ingredient));
                ingredient.title = ingredient.title + " (велика піца)";
                ingredient.price = ingredient.price * 2;
            }

            this.product.additionaIngredients.push(ingredient);
            this.$forceUpdate();
        },

        changeSauceQuanity(way, id) {
            if (way == 'plus') {
                let index = this.ingredients.findIndex(e => e.id == id);
                let ingredient = this.ingredients[index];
                this.addSauce(ingredient);
            }
            else if (way == 'minus') {
                let index = this.ingredients.findIndex(e => e.id == id);
                let ingredient = this.ingredients[index];
                this.$set(this.ingredients[index], 'selected', false);
                let ingredientIndex = this.product.additionaIngredients.findIndex(e => e.id == ingredient.id);
                this.product.additionaIngredients.splice(ingredientIndex, 1);
                this.$forceUpdate();
            }
        },

        getIngredientQuanity(id) {
            let ingredients = this.product.additionaIngredients.filter(e => e.id == id);
            return ingredients.length;
        },

        getIngredientInfo(id) {
            let ingredient = this.ingredients.find(e => e.id == id);
            return ingredient;
        },

        addToCart() {
            dataLayer.push({
                'event': 'addToCart'
            });

            this.product.quanity = this.quanity;
            if(this.product.category_id == 1) {
                this.product.size = this.sizeName;
            }
            else if(this.product.category_id == 2) {
                this.product.size = this.product.volume + ' ml';
            }
            else {
                if(this.product.volume > 0) {
                    this.product.size = this.product.volume + ' г';
                }
                else if(this.product.weight_30 > 0) {
                    this.product.size = this.product.weight_30 + ' г';
                }
            }

            this.product.price = this.getPrice();
            this.product.priceWithoutAdditionals = this.getPriceWithoutAdditionals();
            this.$store.commit('addToCart', this.product);
            this.finished = true;
            if (window.innerWidth > 1024) {
                this.close();
            }
        },

        routerToRoute(name) {
            this.close();
            this.$router.push({name: name, params: {location_city: this.$route.params.locationCity}});
        },

        changeQuanity(way) {
            if (way == 'minus') {
                if (this.quanity == 1) {
                    return;
                }
                this.quanity--;
            }
            else if (way == 'plus') {
                this.quanity++;
            }
        }
    },

    mounted() {
        this.product = this.$store.state.currentProduct;
        this.product.additionaIngredients = [];

        if (!this.product.price_30) {
            this.changeSize(this.sizes[1]);
        }

        axios.get(`${Vue.prototype.SERVER_URL}/api/${JSON.parse(localStorage.getItem('locationCityId'))}/ingredients`).then(response => {
            this.ingredients = response.data;
            this.filteredIngredients = this.ingredients.filter(e => e.show == 1);
            this.sauces = this.ingredients.filter(e => e.is_sauce == 1);
            this.loaded = true;
        });
    }
}
</script>

<style>
.add-product-modal-overlay {
    width: 100%;
    height: 100%;
    background-color: rgba(70, 70, 70, 0.9);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
}

.add-product-modal {
    z-index: 101;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    display: flex;
    flex-direction: column;
    align-items: center;

    height: 96%;
    min-height: 563px;
    width: 90%;
    max-width: 560px;

    padding: 34px 40px 21px;
    border: 1px solid #eee;
    border-radius: 8px;
    background-color: #fff;
    overflow-y: auto;
}

.add-product-modal__head {
    display: flex;
    width: 100%;
    margin-bottom: 30px;
}

.add-product-modal__head-img {
    max-height: 120px;
}

.add-product-modal__head-info {
    width: 100%;
    padding-left: 14px;
}

.add-product-modal-close-section {
    display: flex;
    justify-content: space-between;
    width: 100%;
}

.add-product-modal-close-icon {
    cursor: pointer
}

.add-product-modal-title {
    margin-bottom: 8px;

    font-size: 1.2rem;
    font-weight: 700;
    text-align: left;
}

.add-product-modal__quantity {
    display: flex;
    justify-content: space-between;
    align-items: center;

    width: 100%;
    margin-bottom: 20px;
}

.add-product-modal__quantity-price {
    font-size: 1.15rem;
    font-weight: 700;
}

.add-product-modal__total-price {
    font-size: 1.15rem;
    font-weight: 700;
}

.quantity-box {
    display: flex;
    justify-content: center;
}

.add-product-modal__quantity input,
.add-product-modal__quantity input:focus,
.add-product-modal__quantity input:active {
    width: 54px;
    border: unset !important;
    text-align: center;
    background: unset;
    color: black;
    outline: none;
}

.quanity-input {
    width: 54px;
    text-align: center;
}

.dark input.quanity-input {
    color: white;
}

.quanity-button {
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: center;

    height: 24px;
    width: 24px;

    border: 1px solid #AB2321;
    border-radius: 3px;
    color: white;
    cursor: pointer;
}

.quanity-button--minus {
    color: black;
}

.quanity-button--plus {
    background-color: #AB2321;
}

.add-product-modal-products-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    width: 100%;
}

.add-product-modal-products {
    width: 100%;

    color: black;
    font-size: 0.9rem;
    text-align: left;
}

.add-product-modal-checkout-section {
    width: 100%;
    margin-top: auto;
    padding: 14px;
}

.add-product-modal-buttons-box {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
}

.size-box {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 100%;

    margin-bottom: 24px;

    border-radius: 6px;
    text-align: center;
    background: #D8D8D8;

    .size-selected, .size {
        display: flex;
        align-items: center;
        justify-content: center;

        width: 50%;
        height: 40px;

        margin: 0;
        border: unset;
        border-radius: 6px;
        line-height: 40px;
    }
}

.size-selected {
    color: white;
    background: #AB2321;
    font-weight: 700;
}

.size {
    background: #D8D8D8;
    cursor: pointer;
}

.finished-section {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
}

.make-order {
    display: none;
}

.ingredient-button {
    display: flex;
    width: fit-content;

    padding: 6px 12px;
    cursor: pointer;
}

.ingredients {
    width: 100%;
    margin-bottom: 18px;
}

.sauces {
    width: 100%;

    .ingredient-box {
        height: 220px;
    }
}

.ingredients-button {
    display: flex;
    width: fit-content;
    border: 1px solid #2c3e50;
    padding: 4px;
    padding-left: 8px;
    padding-right: 8px;
    border-radius: 8px;
    cursor: pointer;
    margin-left: 14px;
    margin-bottom: 14px;
    font-weight: bold;
    font-size: 1.2rem;
    border: 1px solid rgb(0, 0, 0);
    color: rgb(0, 0, 0);
    margin: 0px;
}

.selected-ingredients {
    margin-top: 7px;
    padding: 7px 0 14px;

    text-align: left;
    font-weight: bold;
    font-size: 0.8rem;
    color: #000;
}

.selected-ingredients__title {
    color: #505050;
    font-weight: bold;
}

.dark {
    .selected-ingredients {
        color: #ffffff;
    }
}

.unchecked-mark {
    width: 20px;
    height: 20px;
    border: 1px solid black;
    border-radius: 100%;
}

.unchecked-mark, .checked-mark {
    margin-right: 10px;
}

.ingredient-button {
    .checked-mark {
        display: none;
    }
    .unchecked-mark {
        display: block;
    }
}

.ingredient-button.ingredient-button-selected {
    .checked-mark {
        display: block;
    }
    .unchecked-mark {
        display: none;
    }
}

.ingredients-section {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;

    flex-direction: column;
    max-height: 380px;
    overflow-x: auto;
}

.ingredients-section::-webkit-scrollbar {
    width: 0.2em;
}

.ingredients-sectionody::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.ingredients-section::-webkit-scrollbar-thumb {
    background-color: darkgrey;
    outline: 1px solid slategrey;
}

.ingredient-box {
    position: relative;
    overflow: hidden;

    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;

    width: 30%;
    height: 170px;

    border: 1px solid #343434;
    border-radius: 6px;

    cursor: pointer;

    & img {
        max-width: 70px;
        width: 100%;
    }
}

.ingredient-box-selected {
    background: rgba(171, 35, 33, 0.2);

    .ingredient-box__content {
        box-shadow: 0 -5px 15px rgba(171, 35, 33, 0.2);
        background: rgba(171, 35, 33, 0.2);
    }
}

.ingredient-box__img {
    position: absolute;
    top: 22px;
    left: 50%;
    transform: translateX(-50%);

    width: 100%;
}

.ingredient-box__content {
    position: relative;
    z-index: 1;

    width: 100%;

    margin-top: 14px;
    padding: 6px 18px 12px;

    line-height: 140%;
    text-align: center;

    box-shadow: 0 -5px 15px rgb(255 255 255);
    background: rgba(255,255,255,0.9);
}

.dark {
    .ingredient-box__content {
        box-shadow: 0 -5px 15px #262323;
        background: rgba(38,35,35,0.9);
    }

    .ingredient-box-selected {
        .ingredient-box__content {
            box-shadow: 0 -5px 15px #26232340;
            background: rgba(38,35,35,0.2);
        }
    }
}

.ingredients__list {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;

    width: 100%;

    margin-bottom: 24px;
    padding: 0;
}

.ingredients__item {
    margin: 0;
    font-size: 0.8rem;
}

.add-product-modal {
    .add-to-card-button {
        width: 100%;
        margin-top: 26px;

        &.make-order {
            width: auto;
        }
    }
}

@media only screen and (max-width: 1024px) {
    .make-order {
        display: inline-block;
    }

    .add-product-modal {
        height: 100%;
        width: 100%;
        overflow-y: auto;
        border-radius: unset;
        top: 0;
        left: 0;
        transform: unset;
        border: unset;
    }

    .add-product-modal-checkout-section {
        position: static;
    }
}

.dark {
    .add-product-modal-products {
        color: white;
    }

    .quanity-button--minus {
        color: white;
    }

    .size-box {
        background: #0C0C0C;
    }
    .size {
        background: #0C0C0C;
    }

    .unchecked-mark {
        border-color: white;
    }
}
</style>